import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { MultipleContactWarning } from 'legacy/lut/components/common/multipleContactWarning/MultipleContactWarning'
import { useEffect, useState } from 'react'

import { ContactWorkflowStatus } from 'clickNgo/entities/contact'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { isNewContact } from '../contactEditDialog/helpers/isNewContact'
import { useContactCodesStatus } from '../useHooks/useContactCodesStatus'

import styles from './Cell.module.scss'

interface IProps {
  item: DataModel
}

export const ContactStatusIcon = ({ item }: IProps) => {
  const [indicatorStatus, setIndicatorStatus] = useState('')

  const contactId = item.get('ContactID')
  const workflowStatus = item.get('WorkflowStatus')
  const codeStatus = item.get('ContactCodeStatus')
  const email = item.get('Email')

  const otherCodesStatus = useContactCodesStatus(
    codeStatus && codeStatus !== 'Done' ? contactId : ''
  )

  useEffect(() => {
    if (workflowStatus && workflowStatus !== 'Done') {
      setIndicatorStatus(workflowStatus)
    } else if (codeStatus && codeStatus !== 'Done') {
      setIndicatorStatus(codeStatus)
    } else {
      setIndicatorStatus('')
    }
  }, [contactId, workflowStatus, codeStatus])

  if (!indicatorStatus) {
    return <div className={styles.requestIndicator} />
  }

  return (
    <>
      <Tooltip
        className={styles.requestIndicator}
        horizontalStartPosition={TPopupHorizontal.Right}
        horizontalDirection={TPopupHorizontal.Right}
        tipContent={() => (
          <div className={styles.requestIndicatorTipContent}>
            {workflowStatus ? <p>{`Workflow Status: ${workflowStatus}`}</p> : null}
            {codeStatus && !otherCodesStatus ? <p>{`Contact Code Status: ${codeStatus}`}</p> : null}
            {otherCodesStatus ? (
              <>
                {otherCodesStatus['UserRights'] ? (
                  <p>{`UserRights Status: ${otherCodesStatus['UserRights']}`}</p>
                ) : null}
                {otherCodesStatus['Campaigns'] ? (
                  <p>{`Campaigns Status: ${otherCodesStatus['Campaigns']}`}</p>
                ) : null}
                {otherCodesStatus['Tools'] ? (
                  <p>{`Tools Status: ${otherCodesStatus['Tools']}`}</p>
                ) : null}
              </>
            ) : null}
          </div>
        )}
      >
        <div
          className={classNames(
            styles.requestIndicator,
            styles[`requestIndicator${indicatorStatus}`]
          )}
        >
          <div className={styles.requestIndicatorItem} />
        </div>
      </Tooltip>
      {workflowStatus === ContactWorkflowStatus.Draft && isNewContact(contactId) && (
        <div className={styles.multipleContactWarning}>
          <MultipleContactWarning email={email} />
        </div>
      )}
    </>
  )
}
